import {useNavigate} from "react-router";
import createId, {IdType} from "../../models/create-id";
import type {GroupRepo} from "../../models/GroupRepo";
import {Col} from "../../ui/Box";
import {AddRecipeForm} from "./RecipeForms";

const AddRecipe = ({groupRepo}: {groupRepo: GroupRepo}) => {
  const navigate = useNavigate();
  const handleSubmit = ({recipeName}: {recipeName: string}) => {
    const rcpId = createId(IdType.Recipe);
    groupRepo.Recipes.set(rcpId, {
      id: rcpId,
      description: null,
      name: recipeName,
      defaultPortions: 2,
      coverImage: null,
    });

    navigate(`../${rcpId}/edit`);
  };

  return (
    <Col sp="24" maxWidth="formWidth" width="100%" mr="auto" ml="auto" pb="24">
      <h1>Add Recipe</h1>
      <AddRecipeForm onSubmit={handleSubmit} />
    </Col>
  );
};

export default AddRecipe;
